export function useNotFoundSensors() {
  // 异常态页面浏览
  function SD_AbnormalPageView(page_name: string) {
    try {
      const sdEventName = 'AbnormalPage_View';
      const sdEventParams = {
        page_name,
      };
      window.voo_sensors.sensorsTrack(sdEventName, sdEventParams);
    } catch (e) {
      console.log(e);
    }
  }
  // 异常态页面按钮点击
  function SD_AbnormalPageBtnClick(page_name: string, btn_name: string) {
    try {
      const sdEventName = 'AbnormalPageBtn_Click';
      const sdEventParams = {
        page_name,
        btn_name,
      };
      window.voo_sensors.sensorsTrack(sdEventName, sdEventParams);
    } catch (e) {
      console.log(e);
    }
  }
  // 异常态页面按钮点击
  function SD_AbnormalPageValidProductExp(
    sdEventName: string,
    page_name: string,
    product_params: Record<string, any>,
  ) {
    try {
      if (!sdEventName) return;
      const sdEventParams = {
        ...product_params,
        mkt_name: '猜你喜欢',
        page_name,
      };
      window.voo_sensors.sensorsTrack(sdEventName, sdEventParams);
    } catch (e) {
      console.log(e);
    }
  }

  return {
    SD_AbnormalPageView,
    SD_AbnormalPageBtnClick,
    SD_AbnormalPageValidProductExp,
  };
}
